<!-- 首页跳转 校友活动列表页面 -->
<template>
  <div class="active-list">
    <van-list
      class="active-list__list"
      v-model="loading"
      :immediate-check="false"
      :finished="finished"
      finished-text="没有更多了"
      @load="onLoad"
    >
      <div
        v-for="item in activeList"
        :key="item.sh_id"
        class="active-list__item"
        @click="gotoDetails(item)"
      >
        <div
          class="active-list__item-gallery"
          :style="{ backgroundImage: `url(${getImageFullUrl(item.sh_img)})` }"
        >
          <div class="active-list__item-location">{{ item.sh_city }}</div>
          <img
            v-if="false"
            class="active-list__item-status"
            :src="IconActive"
          />

          <div class="active-list__item-gallery-info">
            <span>{{ item.sh_activity_status }}</span>
            <!-- <span>{{ item.shApplyNum }}人已报名</span> -->
          </div>
        </div>
        <div class="active-list__item-info">
          <div class="active-list__item-info-title">
            <span
              v-if="!!item.sh_label"
              class="active-list__item-info-title-label"
              >【{{ item.sh_label }}】</span
            >
            <span>{{ item.sh_title }}</span>
          </div>
          <div class="active-list__item-info-detail">
            <div
              v-for="detail in detailInfoList.slice(0, -1)"
              :key="detail.render(item)"
              class="active-list__item-info-detail-item"
            >
              <img
                class="active-list__item-info-detail-item-icon"
                :src="detail.icon"
              />
              <div class="active-list__item-info-detail-item-value">
                {{ detail.render(item) }}
              </div>
            </div>

            <!-- <div class="active-list__item-info-detail-item" >
              <img
                class="active-list__item-info-detail-item-icon"
                :src="detailInfoList.slice(-1)[0].icon"
              />
              <div v-if="item.sh_num != 0" class="active-list__item-info-detail-item-value">报名进度</div>
              <div v-if="item.sh_num == 0" class="active-list__item-info-detail-item-value">已报名{{ item.sh_applyNum }}人</div>
            </div>

            <div class="active-list__item-info-detail-progress" v-if="item.sh_num != 0">
              <div class="active-list__item-info-detail-progress-bar">
                <div
                  class="active-list__item-info-detail-progress-bar-inner"
                  :style="{ width: `${(item.sh_applyNum / item.sh_num) * 100}%` }"
                />
              </div>
              <div class="active-list__item-info-detail-progress-text">
                {{ item.sh_applyNum }} / {{ item.sh_num }}
              </div>
            </div> -->
          </div>
        </div>
      </div>
    </van-list>

    <div class="active-list__new-activity-btn" @click="onNewActivityBtnClick" />

    <van-dialog
      v-model="isNewActivityDialogShow"
      :showConfirmButton="false"
      closeOnClickOverlay
      closeOnPopstate
      width="24.76rem"
    >
      <div class="active-list__new-activity-content">
        <img
          class="active-list__new-activity-content-bg"
          :src="BgNewActivityTop"
        />
        <div class="active-list__new-activity-content-main">
          <div class="active-list__new-activity-content-title">
            欢迎校友提供更多活动创意！
          </div>
          <div class="active-list__new-activity-content-describe">
            <div>如需自主开展，</div>
            <div>请向校友会办公室申请创建，</div>
            <div>共筑精彩校友时光！</div>
          </div>
          <div class="active-list__new-activity-content-contact">
            校友会办公室电话：024-3269-5566
          </div>
        </div>
        <img
          class="active-list__new-activity-content-bg"
          :src="BgNewActivityBottom"
        />
      </div>
    </van-dialog>
  </div>
</template>

<script>
import dayjs from "dayjs";
import IconActive from "@/assets/image/active/btn_yibaoming_nor.png";
import IconAddress from "@/assets/image/active/btn_fangzi_nor.png";
import IconTime from "@/assets/image/active/btn_shijian_nor.png";
import IconLocation from "@/assets/image/active/btn_dizhi_nor.png";
import IconPerson from "@/assets/image/active/btn_renyuan_nor.png";
import BgNewActivityTop from "@/assets/image/active/btn_shang_nor.png";
import BgNewActivityBottom from "@/assets/image/active/btn_xia_nor.png";
import IconProgress from "@/assets/image/active/btn_baoming_nor.png";

const detailInfoList = Object.freeze([
  {
    icon: IconAddress,
    render: (data) => data.sh_company,
  },
  {
    icon: IconTime,
    render: (data) =>
      `${(data.sh_start_time || "").slice(5)} - ${(data.sh_end_time || "").slice(
        5
      )}`,
  },
  {
    icon: IconLocation,
    render: (data) => data.sh_address,
  },
  {
    icon: IconProgress,
  },
]);

export default {
  data() {
    return {
      detailInfoList,
      BgNewActivityTop,
      BgNewActivityBottom,
      IconProgress,
      IconActive,
      IconPerson,
      loading: false,
      finished: false,
      activeList: [],
      lastPage: "",
      postActive: {
        page: 1,
        pageSize: 5,
      },
      isNewActivityDialogShow: false,
    };
  },
  created() {
    this.getActiveList();
  },
  methods: {
    onNewActivityBtnClick() {
      this.isNewActivityDialogShow = true;
    },

    getImageFullUrl(url) {
      console.log({ url });
      return url;
    },

    async getActiveList() {
      const result = await this.$http.get(
        "/schoolActivity/getAllAchievementList",
        {
          params: {
            currentPage: this.postActive.page,
            perpage: this.postActive.pageSize,
            总数: 100,
          },
        }
      );

      for (let i = 0; i < result.data.list.length; i++) {
        this.activeList.push(result.data.list[i]);
      }

      this.lastPage = result.data.lastPage;
    },
    // 懒加载
    onLoad() {
      this.postActive.page = this.postActive.page + 1;
      this.getActiveList();
      this.loading = false;
      // 数据全部加载完成
      if (this.postActive.page >= this.lastPage) {
        this.finished = true;
      }
    },
    gotoDetails(item) {
      return this.$router.push({
        path: "/activeDetails",
        query: { title: item.sh_title },
      });
    },
  },
};
</script>

<style lang="less" scoped>
.active-list {
  background-color: #fff;
  position: relative;
  min-height: 100%;
}

.active-list__list {
  padding: 1.41rem 1.14rem;
}

.active-list__item {
  position: relative;
  background: #ffffff;
  border-radius: 1.14rem;
  border: 1px solid #aaaaaa;
  overflow: hidden;
  width: 100%;

  & + & {
    margin-top: 1.3rem;
  }
}

.active-list__item-location {
  position: absolute;
  top: -1px;
  left: -1px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 5.03rem;
  height: 1.79rem;
  font-size: 0.99rem;
  color: #ffffff;
  background-image: url("~@/assets/image/active/btn_juxing_nor.png");
  background-size: contain;
}

.active-list__item-status {
  position: absolute;
  top: -1px;
  right: -1px;
  width: 4.04rem;
}

.active-list__item-gallery {
  position: relative;
  height: 12.95rem;
  background-size: cover;
  background-position: center;
}

.active-list__item-gallery-info {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 1.71rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: rgba(0, 0, 0, 0.5);
  padding: 0 0.72rem;
  font-size: 0.99rem;
  color: #ffffff;
  box-sizing: border-box;
}

.active-list__item-info {
  padding: 0.76rem 0.88rem;
}

.active-list__item-info-title {
  font-weight: 400;
  font-size: 1.14rem;
  color: #333333;
  line-height: 1.9rem;
}

.active-list__item-info-title-label {
  color: #d90a0a;
  margin-left: -0.7rem;
}

.active-list__item-info-detail-item {
  display: flex;
  align-items: center;
  margin-top: 0.57rem;
}

.active-list__item-info-detail-item-icon {
  width: 1.18rem;
}

.active-list__item-info-detail-item-value {
  margin-left: 0.53rem;
  font-size: 0.99rem;
  color: #666666;
}

.active-list__new-activity-btn {
  position: fixed;
  right: 1.14rem;
  bottom: 2.14rem;
  z-index: 100;
  width: 3.77rem;
  height: 3.77rem;
  background-image: url("~@/assets/image/active/btn_fabuhuodong_nor.png");
  background-size: cover;
}

.active-list__new-activity-content-main {
  padding: 2.32rem 2.88rem 1.6rem;
}

.active-list__new-activity-content-title {
  font-size: 1.45rem;
  color: #00706e;
  line-height: 2.29rem;
}

.active-list__new-activity-content-bg {
  display: block;
  width: 100%;
}

.active-list__new-activity-content-describe {
  text-align: center;
  margin-top: 2.59rem;
}

.active-list__new-activity-content-contact {
  margin-top: 30px;
  text-align: center;
}

.active-list__item-info-detail-progress {
  margin-top: 0.88rem;
  display: flex;
  align-items: center;
}

.active-list__item-info-detail-progress-bar {
  flex: 1 1 auto;
  // height: 0.76rem;
  background: #f5f5f5;
  border-radius: 0.38rem;
  border: 1px solid #cbcbcb;
  padding: 2px;
  box-sizing: border-box;
}

.active-list__item-info-detail-progress-bar-inner {
  background: #00706e;
  border-radius: 0.27rem;
  height: 0.53rem;
}

.active-list__item-info-detail-progress-text {
  flex: 0 0 auto;
  margin-left: 1em;
}
</style>



// WEBPACK FOOTER //
// src/components/active/ActiveList.vue